import {
  SUMMARY_TIME_FETCHING,
  SUMMARY_TIME_FAILED,
  SUMMARY_TIME_SUCCESS,
  SUMMARY_TIME_INDIVIDUAL_FETCHING,
  SUMMARY_TIME_INDIVIDUAL_FAILED,
  SUMMARY_TIME_INDIVIDUAL_SUCCESS,
} from "./types";

import SummaryTimeService from "../services/summary-time.service";


export const getSummaryTime = (search, query) => async (dispatch) => {
  try {
    dispatch({
      type: SUMMARY_TIME_FETCHING,
    });
    const res = await SummaryTimeService.getSummaryTime(search, query);
    if (res) {
      dispatch({
        type: SUMMARY_TIME_SUCCESS,
        payload: res.data,
      });
    }
  } catch (err) {
    dispatch({
      type: SUMMARY_TIME_FAILED,
    });
    console.log(err);
  }
};

export const getSummaryTimeByIdEmp = (search, query) => async (dispatch) => {
  try {
    dispatch({
      type: SUMMARY_TIME_INDIVIDUAL_FETCHING,
    });
    const res = await SummaryTimeService.getSummaryTime(search, query);
    if (res) {
      dispatch({
        type: SUMMARY_TIME_INDIVIDUAL_SUCCESS,
        payload: res.data,
      });
    }
  } catch (err) {
    dispatch({
      type: SUMMARY_TIME_INDIVIDUAL_FAILED,
    });
    console.log(err);
  }
};
